import Click from "../Event/Click";

const defaultSettings = () => ({
    Btn:null,
    Div:null,
    state:"",//"","top","bottom","right","left","topBottom"
    padding:25,
    isAnchor:true,
    callbackShowDrop:null,
    callbackCloseDrop:null,
    callbackBeforeShowDrop:null,
    callbackBeforeCloseDrop:null,
    closeMode:"windowClick",//"windowClick","btnClick"
    isRelative:true,
    useCapture:false,

});

export default class PopOver  {

    constructor(element, userSettings = {}) {
        if (typeof element === 'string') {
            element = document.querySelector(element);
        }

        if (!element || !element.nodeName) {
            throw new Error('no element is specified to initialize  ');
        }


        this.element = element;

        this.settings = defaultSettings();
        for (const key in userSettings) {
            this.settings[key] = userSettings[key];
        }

        if (!this.settings.Btn || !this.settings.Btn.nodeName) {
            throw new Error('no Btn element is specified to initialize  ');
        }

        if (!this.settings.Div || !this.settings.Div.nodeName) {
            throw new Error('no Div element is specified to initialize  ');
        }

        this.isShow=false;
        this.isAlive = true;

        if(!this.element.classList.contains("popOver" )){
            this.element.classList.add("popOver" );
        }

        if(!this.settings.Div.classList.contains("popOverContent" )){
            this.settings.Div.classList.add("popOverContent" );
        }

        this.Hclick = this.click.bind(this);
        this.HclosingDrop = this.closingDrop.bind(this);

        Click.set(this.settings.Btn,this.Hclick,[],false);
    }

    showDrop() {
        if(!this.isShow) {
            let f=this.settings.callbackBeforeShowDrop;
            if (f !== null) {
                if (f instanceof Function) {
                    f();
                }
            }
            this.showing();
            this.isShow = true;
            let f1=this.settings.callbackShowDrop;
            if (f1 !== null) {
                if (f1 instanceof Function) {
                    f1();
                }
            }
        }
    };

    showing() {
        if (this.settings.isRelative) {
            this.relativePosition();
        }else{
            this.bodyAbsolutePosition();
        }
        this.settings.Div.style.visibility="visible";
        this.settings.Div.style.opacity="1";
        this.settings.Div.style.filter="alpha(opacity=100)";// IE fallback
        if (this.settings.closeMode === "windowClick") {
            document.addEventListener('mousedown', this.HclosingDrop,this.settings.useCapture);
            document.addEventListener('ontouchstart', this.HclosingDrop,this.settings.useCapture);
        }
    };

    closeDrop() {
        if(this.isShow) {
            let f=this.settings.callbackBeforeCloseDrop;
            if (f !== null) {
                if (f instanceof Function) {
                    f();
                }
            }
            this.settings.Div.classList.remove('popTop');
            this.settings.Div.classList.remove('popBottom');
            this.settings.Div.classList.remove('popRight');
            this.settings.Div.classList.remove('popLeft');

            this.settings.Div.style.visibility="hidden";
            this.settings.Div.style.opacity="0";
            this.settings.Div.style.filter="alpha(opacity=0)";// IE fallback

            if (this.settings.closeMode === "windowClick") {
                document.removeEventListener('mousedown',  this.HclosingDrop);
                document.removeEventListener('ontouchstart',  this.HclosingDrop);
            }
            this.isShow = false;

            let f1=this.settings.callbackCloseDrop;
            if (f1 !== null) {
                if (f1 instanceof Function) {
                    f1();
                }
            }
        }
    };

    closingDrop(event) {
        if ( this.settings.Div.contains(event.target)) {
        }else if ( this.settings.Div ===  event.target) {
        }else if (  this.settings.Btn.contains(event.target) ) {
        }else if ( this.settings.Btn ===  event.target ) {
        }else{
            let x = 0, y = 0;
            if(event) {
                let bTouch = false;
                if (event.touches) {
                    if (event.touches.length > 0) {
                        bTouch = true;
                    }
                }
                if (bTouch) {
                    x = event.touches[0].clientX;
                    y = event.touches[0].clientY;
                } else {
                    x = event.clientX;
                    y = event.clientY;
                }
            }
            if(   window.outerWidth <= x ){
                return true;
            }else if( window.outerHeight  <= y ){
                return true;
            }else{
                this.closeDrop();
            }
        }

    };

    relativePosition () {
        let elB = this.settings.Btn;
        let elD =this.settings.Div;
        let rb = elB.getBoundingClientRect();
        let eb = elD.getBoundingClientRect();
        let padding = this.settings.padding;
        let tx = 0;
        let ty = 0;
        //let  top = rb.top - eb.height - padding;
        let bottom = rb.bottom + padding;
        let width = window.innerWidth;
        let height = window.innerHeight;

        //let start = rb.left + rb.width - eb.width;
        let middel = (-eb.width / 2) + (rb.left + rb.width / 2);
        //let end =  rb.left ;

        switch (this.settings.state) {
            case "top":
                tx = -eb.width / 2 + rb.width / 2;
                ty = -eb.height - padding;
                if (this.settings.isAnchor) this.settings.Div.classList.add('popTop');
                break;
            case "bottom":
                tx = -eb.width / 2 + rb.width / 2;
                ty = rb.height + padding;
                if (this.settings.isAnchor) this.settings.Div.classList.add('popBottom');
                break;
            case "topBottom":
                tx = -eb.width / 2 + rb.width / 2;
                if (bottom + eb.height > height) {
                    ty = -eb.height - padding;
                    if (this.settings.isAnchor) this.settings.Div.classList.add('popTop');
                } else {
                    ty = rb.height + padding;
                    if (this.settings.isAnchor) this.settings.Div.classList.add('popBottom');
                }
                break;
            case "right":
                tx = rb.width + padding;
                ty = -eb.height / 2 + rb.height / 2;
                if (this.settings.isAnchor) this.settings.Div.classList.add('popRight');
                break;
            case "left":
                tx = -rb.width - eb.width;
                ty = -eb.height / 2 + rb.height / 2;
                if (this.settings.isAnchor) this.settings.Div.classList.add('popLeft');
                break;
            default: {
                if (rb.left + eb.width <= width) {
                    if (middel - eb.width / 2 > 0) {
                        tx = -eb.width / 2 + rb.width / 2;
                        if (bottom + eb.height > height) {
                            ty = -eb.height - padding;
                            if (this.settings.isAnchor) this.settings.Div.classList.add('popTop');
                        } else {
                            ty = rb.height + padding;
                            if (this.settings.isAnchor) this.settings.Div.classList.add('popBottom');
                        }
                    } else {
                        tx = rb.width + padding;
                        ty = -eb.height / 2 + rb.height / 2;
                        if (this.settings.isAnchor) this.settings.Div.classList.add('popRight');
                    }
                } else {
                    tx = -rb.width - eb.width;
                    ty = -eb.height / 2 + rb.height / 2;
                    if (this.settings.isAnchor) this.settings.Div.classList.add('popLeft');
                }
                break;
            }

        }
        this.settings.Div.style.transform="translate3d(" + tx + "px," + ty + "px,0px)";
    };

    bodyAbsolutePosition () {
        let elB = this.settings.Btn;
        let elD = this.settings.Div;
        let rb = elB.getBoundingClientRect();
        let eb = elD.getBoundingClientRect();
        let padding = this.settings.padding;
        let tx = 0;
        let ty = 0;

        let win = elB.ownerDocument.defaultView;
        //let  top = rb.top - eb.height - padding;
        let bottom = rb.bottom + padding;
        let width = window.innerWidth;
        let height = window.innerHeight;

        //let start = rb.left + rb.width - eb.width;
        let middel = (-eb.width / 2) + (rb.left + rb.width / 2);
        //let end =  rb.left ;

        //let posY = elB.offsetTop - window.scrollTop ;
        //let posX = elB.offsetLeft - window.scrollLeft  ;
        let posY =  rb.top + win.pageYOffset;
        let posX = rb.left + win.pageXOffset;

        switch (this.settings.state) {
            case "top":
                tx = posX -eb.width / 2 + rb.width / 2;
                ty = posY -eb.height - padding;
                if (this.settings.isAnchor) this.settings.Div.classList.add('popTop');
                break;
            case "bottom":
                tx = posX -eb.width / 2 + rb.width / 2;
                ty = posY+rb.height + padding;
                if (this.settings.isAnchor) this.settings.Div.classList.add('popBottom');
                break;
            case "topBottom":
                tx = posX -eb.width / 2 + rb.width / 2;
                if (bottom + eb.height > height) {
                    ty = posY -eb.height - padding;
                    if (this.settings.isAnchor) this.settings.Div.classList.add('popTop');
                } else {
                    ty = posY + rb.height + padding;
                    if (this.settings.isAnchor) this.settings.Div.classList.add('popBottom');
                }
                break;
            case "right":
                tx = posX + rb.width + padding;
                ty = posY -eb.height / 2 + rb.height / 2;
                if (this.settings.isAnchor) this.settings.Div.classList.add('popRight');
                break;
            case "left":
                tx = posX -rb.width - eb.width;
                ty = posY -eb.height / 2 + rb.height / 2;
                if (this.settings.isAnchor) this.settings.Div.classList.add('popLeft');
                break;
            default: {
                if (rb.left + eb.width <= width) {
                    if (middel - eb.width / 2 > 0) {
                        tx = posX -eb.width / 2 + rb.width / 2;
                        if (bottom + eb.height > height) {
                            ty = posY -eb.height - padding;
                            if (this.settings.isAnchor) this.settings.Div.classList.add('popTop');
                        } else {
                            ty = posY + rb.height + padding;
                            if (this.settings.isAnchor) this.settings.Div.classList.add('popBottom');
                        }
                    } else {
                        tx = posX + rb.width + padding;
                        ty = posY -eb.height / 2 + rb.height / 2;
                        if (this.settings.isAnchor) this.settings.Div.classList.add('popRight');
                    }
                } else {
                    tx = posX -rb.width - eb.width;
                    ty = posY -eb.height / 2 + rb.height / 2;
                    if (this.settings.isAnchor) this.settings.Div.classList.add('popLeft');
                }
                break;
            }
        }
        this.settings.Div.style.transform="translate3d(" + tx + "px," + ty + "px,0px)";
    };

    refresh  ( ) {
        if(this.isShow) {
            this.showing();
        }
    };

    click() {
        if(this.settings.closeMode==="windowClick") {
            if(this.isShow ){
                this.closeDrop();
            }else{
                this.showDrop();
            }
        }else if(this.settings.closeMode==="btnClick") {
            if(this.isShow ){
                this.closeDrop();
            }else{
                this.showDrop();
            }
        }
    }

    destroy ( ) {
        this.closeDrop();
        Click.unBind(this.settings.Btn)
    };
}
